import { isObject } from './get-type.utils';
import { ArticleEditError } from '../shared/global-enums';
import moment from 'moment';
import * as EmailValidator from 'email-validator';

export interface Validation {
    valid: boolean;
    message: string;
}

export const booleanTrueValidator = (item: boolean): Validation => {
    if (!item) {
        return {
            valid: false,
            message: 'This field should be chosen',
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const validateEmail = (email: string): Validation => {
    if (!EmailValidator.validate(email)) {
        return {
            valid: false,
            message: 'Email should be valid',
        };
    }

    return {
        valid: true,
        message: '',
    };
};

// TODO: '(item as any)?.value' should be generic key
export const requiredValidator = (item: string | any): Validation => {
    const value: string = isObject(item) ? (item as any)?.value : item;
    return {
        valid: !!value?.toString()?.trim()?.length,
        message: 'This field is required',
    };
};

export const dateValidator = (date: Date | null): Validation => {
    if (date?.toString() === 'Invalid Date') {
        return {
            valid: false,
            message: 'Invalid Date',
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const priceValidator = (price: string): Validation => {
    if (!price) {
        return {
            valid: true,
            message: '',
        };
    }

    if (!/^[0-9]{1,18}(?:\.[0-9]{1,2})?$/.test(price)) {
        return {
            valid: false,
            message: 'Invalid price format',
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const pastDateValidator = (date: Date | null): Validation => {
    if (date && new Date(date).getTime() < new Date().getTime()) {
        return {
            valid: false,
            message: 'Date should not be before minimal date',
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const MIN_DATE_MESSAGE = 'Date cannot be in the past';

export const todayOrFutureDateValidator = (date: Date | null): Validation => {
    if (
        date &&
        !moment(date).isSame(moment(), 'day') &&
        moment(date).isBefore(moment())
    ) {
        return {
            valid: false,
            message: MIN_DATE_MESSAGE,
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const emailValidator = (item = ''): Validation => {
    const re = /(^$|^.*@.*\..*$)/;
    const value = re.test(String(item).toLowerCase());

    return {
        valid: value,
        message: 'Invalid email address',
    };
};

export const maxLengthValidator = (
    length: number,
    maxLength: number
): Validation => {
    if (length > maxLength) {
        return {
            valid: false,
            message: `Maximum ${maxLength} chars`,
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const maxNumberValidator = (
    value: number,
    maxValue: number
): Validation => {
    if (value > maxValue) {
        return {
            valid: false,
            message: `Maximum value is ${maxValue}`,
        };
    }

    return {
        valid: true,
        message: '',
    };
};

export const minNumberOrEmptyValidator = (
    value: number,
    minValue: number
): Validation => {
    if (typeof value === 'string' && value === '')
        return { valid: true, message: '' };

    if (value < minValue) {
        return {
            valid: false,
            message: `Minimum value is ${minValue}`,
        };
    }

    return { valid: true, message: '' };
};

export interface ArticleValidationError {
    errorType: ArticleEditError;
    message: string;
}

export const findError = (
    errorList: ArticleValidationError[],
    errorType: ArticleEditError
): string | undefined => {
    return errorList.find((x) => x.errorType === errorType)?.message;
};
